import React, { useRef, memo } from 'react';

import { IconButton } from '../helpers/IconButton';

const RecipientsHeaderComponent = ({ api, column }) => {
  const headerRef = useRef(null);

  const handleClick = event => {
    column.colDef.onClick(event, api);
  };

  return (
    <div ref={headerRef} className="ag-header-cell-label">
      <IconButton className="mr5" icon="plus" onClick={handleClick} size="sm" title="Add recipient" variant="primary" />
      <span className="mr5">{column.colDef.headerName}</span>
    </div>
  );
};

export const RecipientsHeader = memo(RecipientsHeaderComponent);
